/**
 * Color constants for metric charts
 * Colors match the ScoreDiagram ranges for consistency
 */

/**
 * Green color - used for optimal/excellent performance (80-100)
 */
export const CHART_COLOR_GREEN = '#4ade80';

/**
 * Yellow-green color - used for good performance (60-80)
 */
export const CHART_COLOR_YELLOW_GREEN = '#ACE13A';

/**
 * Amber color - used for moderate performance (40-60)
 */
export const CHART_COLOR_AMBER = '#fbbf24';

/**
 * Red color - used for below-target performance (20-40)
 */
export const CHART_COLOR_RED = '#F04438';

/**
 * Dark red color - used for poor performance (0-20)
 */
export const CHART_COLOR_DARK_RED = '#B42318';

/**
 * Gray color - used for inactive/background regions
 */
export const CHART_COLOR_GRAY = '#e5e7eb';

/**
 * Transparent color - used for chart backgrounds
 */
export const CHART_COLOR_BG_TRANSPARENT = 'transparent';

/**
 * Dark gray color - used for indicators and text
 */
export const CHART_COLOR_INDICATOR = '#414651';
